
export default {
    name: 'Page',
    data() {
        return {}
    }
}
